import { render, staticRenderFns } from "./class_student_add.vue?vue&type=template&id=70372558&scoped=true"
import script from "./class_student_add.vue?vue&type=script&lang=js"
export * from "./class_student_add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70372558",
  null
  
)

export default component.exports